import { z } from 'zod';
import { FileInputFragment } from '@src/generated/graphql';

export type FileType = z.infer<typeof fileSchema>;

export const fileSchema = z.object(
  {
    id: z.string().min(1),
    name: z.string().min(1),
  },
  // i18n.t('translation:validation.file_required', 'A file is required')
  {
    invalid_type_error: 'translation:validation.file_required',
    required_error: 'translation:validation.file_required',
  },
);

export function extractFileInputFromFragment(
  file: FileInputFragment,
): FileType {
  return {
    id: file.id,
    name: file.name,
  };
}
